import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../_models/field.interface"
@Component({
    selector: "app-text-area",
    template: `
    <mat-form-field [formGroup]="group" appearance="none" [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null">
      <span *ngIf="field.mainIcon" [ngClass]="field.mainIcon" class="fa" [ngStyle]="field.styleIcon ? field.styleIcon() : null" (click)="field.onClickIcon()"></span>
      <textarea
        #message
        [maxlength]="field.maxSize" [ngStyle]="field.style()"
        class="{{field.class}}"  matInput [formControlName]="field.name"
        [id]="field.name" [placeholder]="field.label"
        mask="{{ field.mask ? field.mask : null }}"
        autocomplete="off"
        [(ngModel)]="field.value"
        [readonly]="field.disabled"
        [ngClass]="{'cs_disabled' : field.disabled}" ></textarea>
        <mat-hint align="end">{{message.value.length}} / {{ field.maxSize }}</mat-hint>
      <span *ngIf="field.disabled" class="fa fa-lock fa-2x cs_disabled-icone"></span>
      <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error class="cs_input-error" *ngIf="group.get(field.name).hasError(validation.name)">{{validation.message}}</mat-error>
      </ng-container>
    </mat-form-field>
  `,
    styles: []
})
export class TextAreaComponent implements OnInit {
    field: FieldConfig;
    group: UntypedFormGroup;
    constructor() { }
    ngOnInit() { }
}